import Enumerable from "linq";
import { FormatSet } from "../../../domain/format";
import { StringFilterParameter } from "../../system/filters";

export class FormatSetFilterParameter {
  constructor(
    name: string = "",
    formatName: string = "") {
    this.name = new StringFilterParameter(name, true, [" ", "　"]);
    this.formatName = new StringFilterParameter(formatName, true, [" ", "　"]);
  }
  name: StringFilterParameter;
  formatName: StringFilterParameter;

  filter(source: FormatSet): boolean {
    return this.name.filter(source.name)
      && (!this.formatName.keyword || Enumerable.from(source.formats).any(f => this.formatName.filter(f.name)));
  }

  clone(): FormatSetFilterParameter {
    return new FormatSetFilterParameter(
      this.name.keyword,
      this.formatName.keyword,
    );
  }
}
